export var isOpenURLAction = function (action) {
    return action.type === 'openURL';
};
export var isOpenPageAction = function (action) {
    return action.type === 'openPage';
};
export var isOpenTaskpaneAction = function (action) {
    return action.type === 'openTaskpane';
};
export var isOpenDialogAction = function (action) {
    return action.type === 'openDialog';
};
export var isInvokeAPIAction = function (action) {
    return action.type === 'invokeAPI';
};
export var isInvokeBotAction = function (action) {
    return action.type === 'invokeBot';
};
export var isUrlDialog = function (dialogInfo) {
    return dialogInfo.dialogType === 'url';
};
export var isAdaptiveCardDialog = function (dialogInfo) {
    return dialogInfo.dialogType === 'adaptiveCard';
};
//# sourceMappingURL=mosAppActionTypeGuard.js.map